import React, { useState } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import InstagramIcon from "@material-ui/icons/Instagram"
import FacebookIcon from "@material-ui/icons/Facebook"
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline"
import Container from "./Container"

import {
  Button,
} from "@material-ui/core"

import "./Footer.scss"
import DialogCall from "./DialogCall"

const Footer = ({ translation }) => {
  const [open, setOpen] = useState(false)

  return (
    <footer className="footer-wrapper">
      <DialogCall pr={true} open={open} setOpen={setOpen} />
      <Container>
        <div className="footer">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src={`${process.env.PUBLIC_URL}/logo_192_192.jpg`} alt="" width="56" height="56" />
              <span>Yva International</span>
            </Link>
            <p className="footer-tagline">
              {translation.language === "ua" && "Парфумерія, косметика та аюрведичні товари від офіційного імпортера з 2005 року."}
              {translation.language === "ru" && "Парфюмерия, косметика и аюрведические товары от официального импортера с 2005 года."}
            </p>
            <Button
              variant="contained"
              onClick={() => setOpen(true)}
              className="footer-feedback"
              startIcon={<ChatBubbleOutline />}
              disableElevation
            >
              {translation.language === "ua" && "Зворотній зв'язок"}
              {translation.language === "ru" && "Обратная связь"}
            </Button>
          </div>

          <nav className="footer-col" aria-labelledby="footer-info-title">
            <h2 className="footer__title" id="footer-info-title">
              {translation.language === "ua" && "Інформація"}
              {translation.language === "ru" && "Информация"}
            </h2>
            <ul className="footer__list">
              {translation.language === "ua" && (
                <>
                  <li>
                    <Link to="/contacts">Контакти</Link>
                  </li>
                  <li>
                    <Link to="/faq">FAQ</Link>
                  </li>
                  <li>
                    <Link to="/about-us">Про нас</Link>
                  </li>
                  <li>
                    <Link to="/support">Підтримка</Link>
                  </li>
                  <li>
                    <Link to="/publicOfferAgreement">Договір публічної оферти</Link>
                  </li>
                  <li>
                    <Link to="/privacyPolicy">Політика конфіденційності</Link>
                  </li>
                </>
              )}
              {translation.language === "ru" && (
                <>
                  <li>
                    <Link to="/contacts">Контакты</Link>
                  </li>
                  <li>
                    <Link to="/faq">FAQ</Link>
                  </li>
                  <li>
                    <Link to="/about-us">О нас</Link>
                  </li>
                  <li>
                    <Link to="/support">Поддержка</Link>
                  </li>
                </>
              )}
            </ul>
          </nav>

          <div className="footer-col">
            <h2 className="footer__title">
              {translation.language === "ua" && "Ми в соцмережах"}
              {translation.language === "ru" && "Мы в соцсетях"}
            </h2>
            <div className="footer__socials">
              <a
                href="https://www.instagram.com/yva_international/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61594355196669"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </a>
            </div>
          </div>
        </div>
        <div className="rights">
          <p>
            © YVA<sup>®</sup> Natural Products, Inc.
          </p>
          <p>Chernivtsi, Ukraine</p>
        </div>
      </Container>
    </footer>
  )
}

const mapStateToProps = state => {
  return {
    translation: state.translationReducer,
  }
}

export default connect(mapStateToProps)(Footer)
